/**
 * @file
 * Patria box highlights module functionality.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.singleVideoModule = {
    attach: () => {
      if(window.innerWidth < 768) {
        console.log("Mobile");
        return;
      }
      const moduleClass = '.paragraph--type--single-video';

      // Register the ScrollTrigger plugin with GSAP.
      gsap.registerPlugin(ScrollTrigger);

      // Check if box highlights exist on the page.
      if ($(moduleClass).length === 0) {
        return;
      }

      const singleVideoModules = gsap.utils.toArray(moduleClass);
      singleVideoModules.forEach(singleVideoModule => {
        const parent = singleVideoModule.parentElement;
        const nextSibling = parent.nextElementSibling;
        nextSibling.style.position = 'relative';
        ScrollTrigger.create({
          trigger: singleVideoModule,
          start: "top top", 
          end: "bottom 150px",
          pin: true
        });
      });
    }
  };

})(jQuery, Drupal);
